import React, { useState, useEffect } from "react";
import DropdownCT from "./DropdownCT";
import './Arbol.css';

function Arbol() {
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    var [Relation, setRelation] = useState([]);
    var [htmlRelation, setHtmlRelation] = useState(<></>);

    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/CTInverterRelation?idSolarFarm="+idParque, { method: 'GET', credentials: 'include' })
            .then( async(dataRelation) => { setRelation(await dataRelation.json());})
            .catch(e => {console.log(e);})
        setInterval(function () {
            number++;
            fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/CTInverterRelation?idSolarFarm="+idParque, { method: 'GET', credentials: 'include' })
            .then( async(dataRelation) => { setRelation(await dataRelation.json());})
            .catch(e => {console.log(e);})
        }, 50000)
    }, [number]);

    useEffect(()=>{
        htmlRelation = Relation.map((datoRelation, index) => {
        const { idCT, nombreCT, colorCT, inverters } = datoRelation;
    
        return(<DropdownCT key={index} idCT={idCT} invArray={inverters} nombreCT={nombreCT} colorCT={colorCT}/>);
        });
        setHtmlRelation(htmlRelation);
      },[Relation]);

    return(
        <div>
            {htmlRelation}
        </div>
    );
}

export default Arbol